// The mutation texts the offline commands replay and the forms' direct path
// sends, so both issue the same request.

export const CREATE_REMINDER_WORKFLOW = `
  mutation createWorkflow($input: CreateWorkflowInput!) {
    createWorkflow(input: $input) {
      id
      name
    }
  }
`;

export const GET_WORKFLOW_FOR_REPLAY = `
  query getWorkflowForReplay($id: ID!) {
    getWorkflow(id: $id) {
      id
      createdBy {
        id
        keyCloakId
      }
    }
  }
`;

export const ADD_ASSET = `
  mutation Asset($input: AddAssetInput!) {
    asset {
      addAsset(input: $input) {
        id
      }
    }
  }
`;

export const CREATE_TAG_SCAN = `
  mutation Mutation($input: CreateTagScanInput!) {
    createTagScan(input: $input) {
      id
    }
  }
`;
